import { getToken, setToken, removeToken } from '@/utils/auth'
import { signIn, signOut } from '@/api/base'
import {
  fetchGetUserInfo,
  fetchGetFraudsBonusAndPendingBonus,
  fetchResetPasswordAfterLogin,
  fetchGetTrendingChart,
  fetchWithdraw,
} from '@/api/account'

const user = {
  namespaced: true,
  state: {
    token: getToken(),
    loginEmail: undefined,
    balance: undefined,
    balanceUpdateTime: undefined,
    country: undefined,
    name: undefined,
    pendingBonus: undefined,
    fraudsBonus: undefined,
    withdrawAccount: undefined,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_LOGINEMAIL: (state, loginEmail) => {
      state.loginEmail = loginEmail
    },
    SET_BALANCE: (state, balance) => {
      state.balance = balance
    },
    SET_BALANCE_UPDATE_TIME: (state, balanceUpdateTime) => {
      state.balanceUpdateTime = balanceUpdateTime
    },
    SET_COUNTRY: (state, country) => {
      state.country = country
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_PENDING_BONUS: (state, pendingBonus) => {
      state.pendingBonus = pendingBonus
    },
    SET_FRAUDS_BONUS: (state, fraudsBonus) => {
      state.fraudsBonus = fraudsBonus
    },
    SET_WITHDRAW_ACCOUNT: (state, withdrawAccount) => {
      state.withdrawAccount = withdrawAccount
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.account.trim()
      return signIn(username, userInfo.password).then((res) => {
        commit('SET_TOKEN', res.access_token)
        setToken(res.access_token)
      })
    },
    // 登录成功跳转页面后请求首页数据
    afterLogin({ commit, dispatch }) {
      fetchGetUserInfo().then((res) => {
        commit('SET_BALANCE', res.balance)
        commit('SET_BALANCE_UPDATE_TIME', res.balanceUpdateTime)
        commit('SET_COUNTRY', res.country)
        commit('SET_NAME', res.name)
        commit('SET_LOGINEMAIL', res.loginEmail)
        commit('SET_WITHDRAW_ACCOUNT', res.withdrawAccount)
      })
      fetchGetFraudsBonusAndPendingBonus().then((res) => {
        commit('SET_PENDING_BONUS', res.pendingBonus)
        commit('SET_FRAUDS_BONUS', res.fraudsBonus)
      })
      dispatch('link/GetAllActivities', {}, { root: true })
    },
    // 登出
    Logout({ commit }) {
      return signOut().then(() => {
        commit('SET_TOKEN', undefined)
        commit('SET_BALANCE', undefined)
        commit('SET_BALANCE_UPDATE_TIME', undefined)
        commit('SET_COUNTRY', undefined)
        commit('SET_NAME', undefined)
        commit('SET_LOGINEMAIL', undefined)
        commit('SET_LOGINEMAIL', undefined)
        commit('SET_PENDING_BONUS', undefined)
        commit('SET_FRAUDS_BONUS', undefined)
        commit('link/SET_ALL_ACTIVITIES_LIST', undefined, { root: true })
        removeToken()
      })
    },

    // remove token
    resetToken({ commit }) {
      commit('SET_TOKEN', undefined)
      commit('SET_LOGINEMAIL', undefined)
      removeToken()
    },

    // 重置密码（登录后）
    resetPassword({ commit }, formList) {
      return fetchResetPasswordAfterLogin(formList).then(() => {
        commit('SET_TOKEN', undefined)
        commit('SET_LOGINEMAIL', undefined)
        removeToken()
      })
    },

    GetTrendingChart(state, data) {
      return fetchGetTrendingChart(data)
    },
    Withdrawl(state, data) {
      return fetchWithdraw(data)
    },
  },
}

export default user
